/*付款审批 */
import { $http, buildHeaders } from "./index";

//#region 会议管理

//获取列表
export const meetingacounting_page = (params) => {
  return $http.get("/admin/MeetingAccounting/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取待审批详情
export const meetingacounting_detail = (id) => {
  return $http.get(
    "/admin/MeetingAccounting/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取已审批详情
export const meetingacounting_search = (id) => {
  return $http.get(
    "/admin/MeetingAccounting/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//审批
export const meetingacounting_approve = (data) => {
  return $http.post("/admin/MeetingAccounting/approve", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};
